
import { createUseStyles } from 'react-jss';


var styles = {
  outerWrapper: function outerWrapper(props) {return {
      display: 'flex',
      alignItems: 'start',
      width: props.width || '42.2rem'
    };},
  editButton: { textTransform: 'uppercase', marginLeft: '1.2rem', marginTop: '0.4rem' },
  topSelect: {
    marginBottom: '1.2rem'
  },
  select: function select(props) {return {
      width: props.fullWidth && '100%'
    };}
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map